import "@fortawesome/fontawesome-free/css/all.min.css";
import React, { useState } from "react";
import "../Login & Signup/login.css"; // Ensure correct path

const AuthForm = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="auth-body"> {/* This ensures centering */}
      <div
        className={`auth-container ${isActive ? "auth-active" : ""}`}
        id="auth-container"
      >
        {/* Signup Form */}
        <div className="auth-form-container auth-sign-up">
          <form>
            <h1>Create Account</h1>
            <div className="auth-social-icons">
              <a href="#" className="icon">
                <i className="fa-brands fa-google-plus-g"></i>
              </a>
              <a href="#" className="icon">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#" className="icon">
                <i className="fa-brands fa-github"></i>
              </a>
              <a href="#" className="icon">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
            <span>or use your email for registration</span>
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <input type="password" placeholder="Password" />
            <button type="submit" className="auth-button">Sign Up</button>
          </form>
        </div>

        {/* Sign-in Form */}
        <div className="auth-form-container auth-sign-in">
          <form>
            <h1>Sign In</h1>
            <div className="auth-social-icons">
              <a href="#" className="icon">
                <i className="fa-brands fa-google-plus-g"></i>
              </a>
              <a href="#" className="icon">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#" className="icon">
                <i className="fa-brands fa-github"></i>
              </a>
              <a href="#" className="icon">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
            <span>or use your email password</span>
            <input type="email" placeholder="Email" />
            <input type="password" placeholder="Password" />
            <a href="#">Forgot Your Password?</a>
            <button type="submit" className="auth-button">Sign In</button>
          </form>
        </div>

        {/* Toggle Section */}
        <div className="auth-toggle-container">
          <div className="auth-toggle">
            <div className="auth-toggle-panel auth-toggle-left">
              <h1>Welcome Back!</h1>
              <p>Enter your personal details to use all of the site's features</p>
              <button className="auth-hidden " onClick={() => setIsActive(false)}>
                Sign In
              </button>
            </div>
            <div className="auth-toggle-panel auth-toggle-right">
              <h1>Hello, Friend!</h1>
              <p>
                Register with your personal details to use all of the site's
                features
              </p>
              <button className="auth-hidden" onClick={() => setIsActive(true)}>
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> 
  );
};

export default AuthForm;
